import './style.css';
import CookieConsent from './cookieConsent';
import config from './config';

const cookieConsent = new CookieConsent(
  config,
  '//cdn.iubenda.com/cs/iubenda_cs.js'
);
export default cookieConsent;
